import * as React from "react";
import Animations from "../containers/Animations";

const AnimationsPage = () => {
  return <Animations />;
};

export default AnimationsPage;
